const config = {
  TOKEN: "?token=e1d436504ed62f4d7a6ba5c1ae3fa8",
  API_URL: "https://issirinkprofesija.lsmu.lt/backend/api/",
  STORAGE_URL: "https://issirinkprofesija.lsmu.lt/backend/storage/uploads",
  PROGRAMS: "collections/get/programs",
  QUESTIONS: "collections/get/questions",
  TEST_SUBMIT: "forms/submit/mailing_list",
  INTRO_SETTINGS: "singletons/get/intro_settings",
  REGISTRATION_FORM_SETTINGS: "singletons/get/registration_form",
  COMPLETION_SETTINGS: "singletons/get/completion_view",
  TEST_VIEW_SETTINGS: "singletons/get/test_view",
  RESULT_VIEW_SETTINGS: "singletons/get/result_view",
  SETTINGS: "singletons/get/settings"
};

export default config;
